



















































































import { Vue, Component, Watch } from "vue-property-decorator";
import CompanyFileSizeLimit from "@/components/companies/CompanyFileSizeLimit.vue";
import { Company as ICompany } from "@/api/models/company";
import { LearningRequestShort as ILearningRequestShort } from "@/api/models/learning-request-short";
import {
  getCurrentUserId,
  isRoot,
  getCurrentCompanyId,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import { Employee as IEmployee } from "@/api/models/employee";
import learningRequests, {
} from "@/getinfo-api/learning-requests";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import MoneyBlock from "@/components/home-page/MoneyBlock.vue";
import Request from "@/components/home-page/Request.vue";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import ManagerBlock from "@/components/home-page/ManagerBlock.vue";
import { bookkeepingModule } from "@/plugins/modules-detect";
import CFileManager from "@/components/fileManager/CFileManager.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import StatisticByRequests from "@/components/home-page/StatisticByRequests.vue";

@Component({
  components: {
    StatisticByRequests,
    CBlock,
    CFileManager,
    MoneyBlock,
    CompanyFileSizeLimit,
    Request,
    ManagerBlock
  }
})
export default class HomePageCompanyOwner extends Vue {
  companyInfo!: ICompany;
  limit: number = 1000;
  count: number = 0;
  requestCount!: number;
  requests: Array<ILearningRequestShort> = [];
  showSpinner: boolean = false;
  isGetEmployeeSpinner: boolean = false;
  employeeList: Array<IEmployee> = [];

  data() {
    return {
      companyInfo: undefined,
      requestCount: undefined,
      employeeRequestCount: undefined
    };
  }

  get isBookkeepingModule() {
    return bookkeepingModule();
  }

  getEmployeeId() {
    this.isGetEmployeeSpinner = true;
    this.showSpinner = true;
    this.employeeList = [];

    let params: EmployeeListParams = {
      roles: ["learning_request_manager"],
      id: this.selectedCompanyId,
      limit: 300
    };

    employee(params)
      .then((res: { data: IEmployeesList2 }) => {
        this.employeeList = res.data.employees;
      })
      .finally(() => {
        this.isGetEmployeeSpinner = false;
        this.showSpinner = false;
      });
    this.searchOrdersByParams();
  }

  searchOrdersByParams(offset = 0) {
    this.showSpinner = true;
    this.requests = [];
    let count = 0;

    const batchSize = 500;

    const fetchRequests = async () => {
      const params = {
        companyId: this.selectedCompanyId,
        limit: batchSize,
        offset: offset
      };

      try {
        const response = await learningRequests(params);
        count = response.data.count;
        this.requests = this.requests.concat(response.data.requests);
        offset += batchSize;

        if (this.requests.length < count) {
          await fetchRequests();
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        this.showSpinner = false;
      }
    };
    fetchRequests();
  }

  getCompany() {
    this.isGetEmployeeSpinner = true;
    api.CompanyApi.get(this.selectedCompanyId)
      .then((res: { data: ICompany }) => {
        this.companyInfo = res.data;
      })
      .finally(() => {
        this.isGetEmployeeSpinner = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  @Watch("selectedCompanyId", { immediate: true })
  updateInfo() {
    this.getCompany();
    this.getEmployeeId();
  }

  get date() {
    let date = new Date();
    return (
      date.getDate() +
      "." +
      (new Date().getMonth() + 1) +
      "." +
      new Date().getFullYear()
    );
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }
}
